<template>
	<CToaster
		:position="config.position"
		class="toast-wrapper"
	>
		<ToastBox
			v-for="toast in list"
			:key="toast.key"
			:toast="toast"
		/>
	</CToaster>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'TheToastContainer',

	computed: {
		...mapState('toast', {
			list: 'list',
			config: 'config',
		}),
	},
};
</script>
